<div class="cell auto grid-y cell-block-y blockContent grid-padding-y" *ngIf="study">
    <h3 [i18nKey]="'studies.financial.result.investment.title'"></h3>
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'studies.financial.result.investment'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.financial.result.investment.percentage.rate'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.financial.result.investment.amount'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.financial.result.investment.interest'"></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'studies.financial.result.investment.account'"></td>
            <td class="_number">{{study.investmentPercentageRate * 100 | number:'1.2'}}</td>
            <td class="_number">{{study.investmentAmount | number:'1.2'}}</td>
            <td class="_number">{{study.investmentInterest | number:'1.2'}}</td>

        </tr>
        <tr>
            <td [i18nKey]="'studies.financial.result.investment.other.products'"></td>
            <td></td>
            <td></td>
            <td class="_number">{{study.otherFinancialProducts | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.financial.result.investment.total'"></td>
            <td></td>
            <td></td>
            <td class="_number">{{study.totalFinancialProducts | number:'1.2'}}</td>
        </tr>
        </tbody>
    </table>

    <kiwi-spacer [size]="32"></kiwi-spacer>

    <h3 [i18nKey]="'studies.financial.result.loan.title'"></h3>
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'studies.financial.result.loan'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.financial.result.loan.percentage.rate'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.financial.result.loan.amount'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.financial.result.loan.interest'"></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'studies.financial.result.loan.free'"></td>
            <td class="_number">{{study.loanPercentageRate * 100 | number:'1.2'}}</td>
            <td class="_number">{{study.loanAmount | number:'1.2'}}</td>
            <td class="_number">{{study.loanInterest | number:'1.2'}}</td>
        </tr>
        <tr>
            <td [i18nKey]="'studies.financial.result.loan.overdraft'"></td>
            <td></td>
            <td></td>
            <td class="_number">{{study.overdraftCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.financial.result.loan.other.charges'"></td>
            <td></td>
            <td></td>
            <td class="_number">{{study.otherFinancialExpenses | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.financial.result.loan.total'"></td>
            <td></td>
            <td></td>
            <td class="_number">{{study.totalFinancialExpenses | number:'1.2'}}</td>
        </tr>
        </tbody>
    </table>
</div>

